import http from "@/http-common.js";

class AdminSmsService {
  basePathApiService = "/logssms";

  getAll(params) {
    return http.get(this.basePathApiService, params);
  }
}

export default new AdminSmsService();
